/** Search presentation belongs to the morph rendered in the current header,
 * not to search state retained by a view that is no longer on screen. */
export function hasActiveVisibleMobileSearch(
  leadingActions: readonly { id: string }[],
  openByActionId: Readonly<Record<string, boolean>>,
  hiddenOnMobile: ReadonlySet<string>,
): boolean {
  return leadingActions.some(action =>
    openByActionId[action.id] === true && !hiddenOnMobile.has(action.id),
  );
}
